import axios from 'axios';
import { API_BASE_URL } from '../config/api';

const API_BASE = `${API_BASE_URL}/api/auth`;

export const authService = {
  getMe: async () => {
    const response = await axios.get(`${API_BASE}/me`);
    return response.data;
  },

  register: async (displayName) => {
    const response = await axios.post(`${API_BASE}/register`, { displayName });
    return response.data;
  },

  listRoles: async () => {
    const response = await axios.get(`${API_BASE}/roles`);
    return response.data;
  },

  listUsers: async (limit = 50, offset = 0) => {
    const response = await axios.get(`${API_BASE}/users?limit=${limit}&offset=${offset}`);
    return response.data;
  },

  assignRole: async (userId, { roleId, orgEntityId, facilityEntityIds }) => {
    const response = await axios.post(`${API_BASE}/users/${userId}/assignments`, {
      roleId,
      orgEntityId,
      facilityEntityIds
    });
    return response.data;
  },

  revokeAssignment: async (assignmentId) => {
    const response = await axios.delete(`${API_BASE}/assignments/${assignmentId}`);
    return response.data;
  },

  createUser: async ({ email, displayName, password, roleId, orgEntityId }) => {
    const response = await axios.post(`${API_BASE}/users`, {
      email,
      displayName,
      password,
      roleId,
      orgEntityId
    });
    return response.data;
  }
};
